import { Component, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';

@Component({
    selector: 'mobile-fourthlevel-nav',
    templateUrl: 'mobile-fourthlevel-nav.component.html'
})
export class MobileFourthLevelNavComponent implements AfterViewInit, OnDestroy {
    fourthNavLinks: any[];
    navigation: NxiNavigation;
    selectedMenuItem: any;
    @ViewChild('menuSelect', {static : false}) select;
    constructor(private translationService: PershingTranslationService, private navigationService: PortalNavigationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
    }
    // This was done in ngOnInit
    // Variables injected via viewChild will be filled and available only after AfterViewInit lifecycle
    ngAfterViewInit(): void {
        console.log(' In Component ngAfterViewInit ');
        this.navigationService.getGrandChildPage().subscribe(
            thirdlevelpage => {
                console.log('currentpage', thirdlevelpage);
                if (thirdlevelpage !== undefined) {
                   if (thirdlevelpage.children !== undefined) {
                        this.fourthNavLinks = thirdlevelpage.children;
                    }
                }
            });
        this.navigationService.getFourthChildPage().subscribe(
            fourthchildpage => {
                if (fourthchildpage) {
                    this.select.value = fourthchildpage.name;
                    this.selectedMenuItem = fourthchildpage.name;
                }
                console.log(' 4th childpage-- ' + fourthchildpage);
            }
        );
    }
    public ngOnDestroy() {
        console.log(' In MobileFourthLevelNavComponent Destroy ');
    }
    handleNavigation(childpage): void {
        if (this.selectedMenuItem !== childpage.name) {
            this.navigation = new NxiNavigation();
            this.navigation.fourthchildPage = childpage;
            this.navigationService.handleNavigation(this.navigation);
        }
    }
}
